import { render, staticRenderFns } from "./BlacklistRegistration.vue?vue&type=template&id=37e78abc&scoped=true&"
import script from "./BlacklistRegistration.vue?vue&type=script&lang=js&"
export * from "./BlacklistRegistration.vue?vue&type=script&lang=js&"
import style0 from "./BlacklistRegistration.vue?vue&type=style&index=0&id=37e78abc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e78abc",
  null
  
)

export default component.exports